const PLAN_CARD_WIDTH = 308;
const PLAN_CARD_GAP = 16;
const PLANS_PAGE_SIDE_PADDING = 40;
const BUNDLE_COLUMNS_GAP = 32;
const SUBSCRIPTIONS_COLUMN_DIVIDER_OFFSET = 30;

const getCardsRowWidth = (cardCount) => {
    const normalizedCardCount = Math.max(0, Number(cardCount) || 0);
    if (normalizedCardCount === 0) {
        return 0;
    }
    return (normalizedCardCount * PLAN_CARD_WIDTH) + ((normalizedCardCount - 1) * PLAN_CARD_GAP);
};

export const shouldUseCompactPlansLayout = ({
    viewportWidth,
    subscriptionCardCount = 0,
    bundleCardCount = 0,
}) => {
    const normalizedViewportWidth = Number(viewportWidth);
    if (!Number.isFinite(normalizedViewportWidth) || normalizedViewportWidth <= 0) {
        return false;
    }

    const normalizedSubscriptionCardCount = Math.max(0, Number(subscriptionCardCount) || 0);
    const normalizedBundleCardCount = Math.max(0, Number(bundleCardCount) || 0);
    const availableWidth = Math.max(normalizedViewportWidth - (PLANS_PAGE_SIDE_PADDING * 2), 0);

    if (normalizedBundleCardCount > 0) {
        const requiredWidth = getCardsRowWidth(normalizedBundleCardCount)
            + getCardsRowWidth(normalizedSubscriptionCardCount)
            + BUNDLE_COLUMNS_GAP
            + (normalizedSubscriptionCardCount > 0 ? SUBSCRIPTIONS_COLUMN_DIVIDER_OFFSET : 0);
        return availableWidth < requiredWidth;
    }

    return availableWidth < getCardsRowWidth(normalizedSubscriptionCardCount);
};
